import { useNavigate, Outlet, Link } from 'react-router-dom';
import { Header } from '../../../components/SpearParts/Layouts/Header';
import { SeachSection } from '../../../components/SpearParts/Layouts/SeachSection';
import NoData from '../../../components/NoData/Index';
import Advancedfilter from '../../AdvancedFilter/Advancedfilter';
import Axios from '../../../axios/axios';



import Brand from '../../../components/SpearParts/Layouts/Brand';

import { Catalogue } from '../../../components/SpearParts/Layouts/Catalogue';
import { About } from '../../../components/Engineering/Layout/About';
import { Footer } from '../../../components/SpearParts/Layouts/Footer';

import { useEffect, useState } from 'react';

// export const getCompleteData = async (
//   setEngineeringModels,
//   setEngineeringBrand,
//   setEngineeringCategory
// ) => {
//   try {
//     const response = await Axios.get("/type-based-details");    
//     setEngineeringModels(response.data.engineering.models);    
//     setEngineeringBrand(response.data.engineering.brands);
//     setEngineeringCategory(response.data.engineering.categories);
//   } catch (error) {
//     console.error("Error fetching engineering parts:", error);
//   }
// };

// export const getItems = async (setRegion) => {
//   try {
//     const response = await Axios.get("/regions");
//     console.log(response.data);
//     setRegion(response.data);
//   } catch (error) {
//     console.log(error);
//   }
// };
export const getCompleteData = async (
  setEngineeringModels,
  setEngineeringBrand,
  setEngineeringCategory
) => {
  try {
    const response = await Axios.get("/type-based-details");
    console.log("Complete Data Response:", response.data);
    setEngineeringModels(response.data.engineering.models);
    setEngineeringBrand(response.data.engineering.brands);
    setEngineeringCategory(response.data.engineering.categories);
  } catch (error) {
    console.error("Error fetching engineering parts:", error);
  }
};

export const getItems = async (setRegion) => {
  try {
    const response = await Axios.get("/regions");
    console.log("Regions Response:", response.data);
    setRegion(response.data);
  } catch (error) {
    console.log(error);
  }
};
export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i);
};

export const searchPart = async (filters, page = 1, limit = 10) => {
  try {
    const params = new URLSearchParams({ ...filters, page, limit });
    const response = await Axios.get(`/engparts/searchCombined?${params.toString()}`);
    return response.data || { data: [], total: 0, totalPages: 1, currentPage: 1 };
  } catch (error) {
    console.error("Error fetching engineering parts:", error);
    return { data: [], total: 0, totalPages: 1, currentPage: 1 };
  }
};

export const getFieldValues = async () => {
  try {
    const response = await Axios.get("/parts/field-values");
    console.log("Field Values:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching field values:", error);
    throw error;
  }
};


const EngineeringHome = () => {
  const navigate = useNavigate();
  const [businessType, setBusinessType] = useState(sessionStorage.getItem("businessType") || "");


  const [engineeringModels, setEngineeringModels] = useState([]);
  const [engineeringBrand, setEngineeringBrand] = useState([]);
  const [engineeringCategory, setEngineeringCategory] = useState([]);
  const [engineeringRegion, setEngineeringRegion] = useState("");
  const [region, setRegion] = useState([]);

  useEffect(() => {
    if (businessType) {
      if (businessType === "Engineering") {
        navigate("/engineering-home");
      } else if (businessType === "Building") {
        navigate("/others-home");
      } else {
        navigate("/");
      }
    }
  }, [businessType]);

  useEffect(() => {
    getCompleteData(setEngineeringModels, setEngineeringBrand, setEngineeringCategory);
    getItems(setRegion);
  }, []);

  useEffect(() => {
    getFieldValues();
  }, []);


  return (
    <>
      <div className="engineering-wrapper">
        <About />
        {/* <Footer/> */}
      </div>
    </>
  );
}
export default EngineeringHome